export default __webpack_public_path__ + "static/media/Goldi-Animation.9132ee2b.svg";